"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var Styled = _interopRequireWildcard(require("./Popover.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // eslint-disable-next-line max-lines-per-function


var Popover = function Popover(_a) {
  var _b = _a.ariaLabel,
      ariaLabel = _b === void 0 ? '' : _b,
      _c = _a.ariaLabelButton,
      ariaLabelButton = _c === void 0 ? '' : _c,
      isOpen = _a.isOpen,
      onClose = _a.onClose,
      onOpen = _a.onOpen,
      _d = _a.placement,
      placement = _d === void 0 ? 'left' : _d,
      clickContent = _a.clickContent,
      children = _a.children,
      _e = _a.offset,
      offset = _e === void 0 ? [0, 0] : _e,
      _f = _a.showOnHover,
      showOnHover = _f === void 0 ? false : _f,
      _g = _a.id,
      id = _g === void 0 ? '' : _g;

  var _h = (0, _react.useState)(null),
      referenceElement = _h[0],
      setReferenceElement = _h[1];

  var _j = (0, _react.useState)(null),
      popperElement = _j[0],
      setPopperElement = _j[1];

  var _k = (0, _react.useState)(false),
      isMouseIn = _k[0],
      setIsMouseIn = _k[1];

  var cond = offset && {
    modifiers: [{
      name: 'offset',
      options: {
        offset: offset
      }
    }]
  };

  var _l = (0, _reactPopper.usePopper)(referenceElement, popperElement, (0, _tslib.__assign)({
    placement: placement
  }, cond)),
      styles = _l.styles,
      attributes = _l.attributes;

  var handleOnTargetClick = function handleOnTargetClick() {
    return isOpen ? onClose() : onOpen();
  };

  var onMouseOver = showOnHover ? function () {
    setIsMouseIn(true);
    onOpen();
  } : undefined;
  var onMouseOut = showOnHover ? function () {
    setIsMouseIn(false);
    onClose();
  } : undefined;
  return _react.default.createElement(Styled.SliceBox, {
    "aria-label": ariaLabel
  }, _react.default.createElement(Styled.PopperButton, {
    "aria-controls": id,
    "aria-expanded": isOpen,
    "aria-label": ariaLabelButton,
    "data-testid": "popover__onclick",
    onClick: !isMouseIn ? handleOnTargetClick : undefined,
    onTouchEnd: function onTouchEnd() {
      return setIsMouseIn(false);
    },
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    ref: setReferenceElement,
    type: "button"
  }, clickContent), _react.default.createElement(_Box.default, {
    id: id
  }, isOpen && _react.default.createElement(Styled.Popper, (0, _tslib.__assign)({
    ref: setPopperElement
  }, attributes.popper, {
    style: styles.popper
  }), children)));
};

var _default = Popover;
exports.default = _default;